function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
module.exports = _extends;
});

var runtime_1 = createCommonjsModule(function (module) {
var runtime = (function (exports) {
  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1;
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);
    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }
  exports.wrap = wrap;
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }
  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };
  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    IteratorPrototype = NativeIteratorPrototype;
  }
  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }
  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };
  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };
  exports.awrap = function(arg) {
    return { __await: arg };
  };
  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }
        return Promise.resolve(value).then(function(unwrapped) {
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          return invoke("throw", error, resolve, reject);
        });
      }
    }
    var previousPromise;
    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise =
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }
    this._invoke = enqueue;
  }
  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );
    return exports.isGeneratorFunction(outerFn)
      ? iter
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };
  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }
      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }
        return doneResult();
      }
      context.method = method;
      context.arg = arg;
      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if (context.method === "next") {
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }
          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }
        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;
          if (record.arg === ContinueSentinel) {
            continue;
          }
          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      context.delegate = null;
      if (context.method === "throw") {
        if (delegate.iterator["return"]) {
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);
          if (context.method === "throw") {
            return ContinueSentinel;
          }
        }
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }
    var info = record.arg;
    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }
    if (info.done) {
      context[delegate.resultName] = info.value;
      context.next = delegate.nextLoc;
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }
    } else {
      return info;
    }
    context.delegate = null;
    return ContinueSentinel;
  }
  defineIteratorMethods(Gp);
  Gp[toStringTagSymbol] = "Generator";
  Gp[iteratorSymbol] = function() {
    return this;
  };
  Gp.toString = function() {
    return "[object Generator]";
  };
  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };
    if (1 in locs) {
      entry.catchLoc = locs[1];
    }
    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }
    this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }
  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }
      next.done = true;
      return next;
    };
  };
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }
      if (typeof iterable.next === "function") {
        return iterable;
      }
      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }
          next.value = undefined$1;
          next.done = true;
          return next;
        };
        return next.next = next;
      }
    }
    return { next: doneResult };
  }
  exports.values = values;
  function doneResult() {
    return { value: undefined$1, done: true };
  }
  Context.prototype = {
    constructor: Context,
    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined$1;
      this.tryEntries.forEach(resetTryEntry);
      if (!skipTempReset) {
        for (var name in this) {
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },
    stop: function() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }
      return this.rval;
    },
    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }
      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        if (caught) {
          context.method = "next";
          context.arg = undefined$1;
        }
        return !! caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;
        if (entry.tryLoc === "root") {
          return handle("end");
        }
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        finallyEntry = null;
      }
      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;
      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }
      return this.complete(record);
    },
    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }
      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
      return ContinueSentinel;
    },
    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };
      if (this.method === "next") {
        this.arg = undefined$1;
      }
      return ContinueSentinel;
    }
  };
  return exports;
}(
   module.exports 
));
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
var asyncToGenerator = _asyncToGenerator;

var detector = {
  iqiyi: function iqiyi() {
    return !!navigator.userAgent.match(/iqiyi\s*IqiyiVersion\/([\d.]+)/i);
  },
  zhishi: function zhishi() {
    return !!navigator.userAgent.match(/knowledge\s*KnowledgeVersion\/([\d.]+)/i);
  },
  chrome: function chrome() {
    return !!navigator.userAgent.match(/Chrome\/([\d.]+)/) || !!navigator.userAgent.match(/CriOS\/([\d.]+)/);
  },
  android: function android() {
    return !!navigator.userAgent.match(/(Android);?[\s/]+([\d.]+)?/);
  },
  iOS: function iOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  iOSEgt9: function iOSEgt9() {
    return this.iOS() && /OS (\d+)/i.exec(navigator.userAgent)[1] >= 9;
  },
  iPad: function iPad() {
    return /iPad/.test(navigator.userAgent) && !window.MSStream;
  },
  iPhoneX: function iPhoneX() {
    if (typeof window !== 'undefined') {
      return /iphone/gi.test(navigator.userAgent) && window.screen.height >= 812;
    }
    return false;
  },
  vivo: function vivo() {
    return !!navigator.userAgent.match(/vivo (\w+) /i);
  },
  qq: function qq() {
    return !!navigator.userAgent.match(/(QQBrowser)\/([\d.]+)/);
  },
  uc: function uc() {
    return !!navigator.userAgent.match(/UCBrowser/i);
  },
  baidu: function baidu() {
    return !!navigator.userAgent.match(/baidu/i);
  },
  wechat: function wechat() {
    return /MicroMessenger/.test(navigator.userAgent);
  }
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var Ajax =
function () {
  _createClass(Ajax, null, [{
    key: "create",
    value: function create() {
      var XHR = window.XMLHttpRequest || window.ActiveXObject;
      return new XHR('MSXML2.XMLHTTP.3.0');
    }
  }, {
    key: "request",
    value: function request() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var opt = {};
      if (typeof options === 'string') {
        opt = {
          url: options
        };
      } else {
        opt = Object.assign({}, options);
      }
      return new Promise(function (resolve, reject) {
        var request = opt.xhr || Ajax.create();
        var resolved = false;
        for (var k in Ajax.defaultOptions) {
          if (typeof opt[k] === 'undefined') {
            opt[k] = Ajax.defaultOptions[k];
          }
        }
        request.open(opt.method || 'GET', opt.url, !!opt.async);
        if (opt.headers) {
          var _opt = opt,
              headers = _opt.headers;
          for (var _k in headers) {
            if (headers.hasOwnProperty(_k)) {
              request.setRequestHeader(_k, headers[_k]);
            }
          }
        }
        if (opt.responseType) {
          request.responseType = opt.responseType;
        }
        request.onreadystatechange = function () {
          if (request.readyState === 4) {
            var parse = function parse(req) {
              var result;
              if (opt.responseType === 'text' && typeof req.responseText === 'string') {
                result = req.responseText;
              } else if (typeof req.response !== 'undefined') {
                if (opt.responseType === 'json' && typeof req.response === 'string') {
                  result = JSON.parse(req.response);
                } else {
                  result = req.response;
                }
              } else {
                try {
                  if (opt.responseType === 'json' && typeof req.responseText === 'string') {
                    result = JSON.parse(req.responseText);
                  } else {
                    result = req.responseText;
                  }
                } catch (ex) {
                  result = req.responseText;
                }
              }
              return result;
            };
            resolved = true;
            if (request.status >= 200 && request.status < 300 || request.status === 304) {
              resolve(parse(request));
            } else {
              reject(request);
            }
          }
        };
        request.onerror = function () {
          resolved = true;
          reject(request);
        };
        request.onabort = function () {
          resolved = true;
          reject(request);
        };
        request.addEventListener('progress', function (e) {
          var done = e.loaded || e.position;
          var total = e.total || e.totalSize;
          if (typeof opt.notify === 'function') {
            opt.notify(done, total);
          }
        }, false);
        if (request.upload) {
          request.upload.onprogress = function (e) {
            var done = e.loaded || e.position;
            var total = e.total || e.totalSize;
            if (typeof opt.notify === 'function') {
              opt.notify(done, total);
            }
          };
        }
        var _opt2 = opt,
            data = _opt2.data;
        if (data !== undefined) {
          request.send(opt.data);
        } else {
          request.send();
        }
        if (opt.timeout) {
          setTimeout(function () {
            if (!resolved) {
              request.timeout = true;
              request.status = 0;
              reject(request);
            }
          }, opt.timeout);
        }
      });
    }
  }, {
    key: "head",
    value: function head(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var opt = Object.assign({}, options);
      opt.url = url;
      opt.method = 'HEAD';
      return this.request(opt);
    }
  }, {
    key: "get",
    value: function get(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var opt = Object.assign({}, options);
      opt.url = url;
      opt.method = 'GET';
      return this.request(opt);
    }
  }, {
    key: "post",
    value: function post(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 ? arguments[2] : undefined;
      var opt = Object.assign({}, options);
      opt.url = url;
      opt.method = 'POST';
      if (data !== undefined) {
        opt.data = data;
      }
      return this.request(opt);
    }
  }, {
    key: "put",
    value: function put(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 ? arguments[2] : undefined;
      var opt = Object.assign({}, options);
      opt.url = url;
      opt.method = 'PUT';
      if (data !== undefined) {
        opt.data = data;
      }
      return this.request(opt);
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var opt = Object.assign({}, options);
      opt.url = url;
      opt.method = 'DELETE';
      return this.request(opt);
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        async: true,
        timeout: 1000 * 60,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-type': 'application/json'
        }
      };
    }
  }]);
  function Ajax() {
    _classCallCheck(this, Ajax);
    this.xhr = this.constructor.create();
  }
  _createClass(Ajax, [{
    key: "request",
    value: function request() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var opt = {};
      if (typeof options === 'string') {
        opt = {
          url: options
        };
      } else {
        opt = Object.assign({}, options);
      }
      opt.xhr = this.xhr;
      return Ajax.request(opt);
    }
  }, {
    key: "head",
    value: function head() {
      var _Ajax$head;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_Ajax$head = Ajax.head).call.apply(_Ajax$head, [this].concat(args));
    }
  }, {
    key: "get",
    value: function get() {
      var _Ajax$get;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return (_Ajax$get = Ajax.get).call.apply(_Ajax$get, [this].concat(args));
    }
  }, {
    key: "post",
    value: function post() {
      var _Ajax$post;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return (_Ajax$post = Ajax.post).call.apply(_Ajax$post, [this].concat(args));
    }
  }, {
    key: "put",
    value: function put() {
      var _Ajax$put;
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return (_Ajax$put = Ajax.put).call.apply(_Ajax$put, [this].concat(args));
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _Ajax$delete;
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return (_Ajax$delete = Ajax["delete"]).call.apply(_Ajax$delete, [this].concat(args));
    }
  }]);
  return Ajax;
}();

var SCHEMA = {
  IQIYI: 'iqiyi',
  KNOWLEDGE: 'knowledge',
  PLUGIN: 'plugin'
};
var PKG = {
  ANDROID: 'com.iqiyi.knowledge',
  IOS: 'knowledge://mobile/register_business/com_iqiyi_knowledge'
};
var URL = {
  zhishiOtaLink: '//ota.iqiyi.com/f4.jsp?url=zhishi_h5',
  zhishiLink: '//zhishi.m.iqiyi.com/campaign/download/',
  iqiyiLink: '//www.iqiyi.com/app/register_business/index.html',
  zhishiQQLink: '//a.app.qq.com/o/simple.jsp?pkgname=com.iqiyi.knowledge',
  iqiyiQQLink: '//a.app.qq.com/o/simple.jsp?pkgname=com.qiyi.video',
  iqiyiULink: '//www.iqiyi.com/app/register_business/index.html',
  zhishiULink: '//www.iqiyi.com/knowledge/ulink/register_business/index.html'
};

function prepare () {
  return new Promise(function (resolve, reject) {
    if (typeof iqiyi === 'undefined') {
      reject(new Error("initIqy error: iqiyi not found, please detect iqiyi sdk has been installed!"));
      return;
    }
    iqiyi.ready(function (result) {
      if (!result) {
        reject(new Error('initIqy error: iqiyi.ready'));
        return;
      }
      resolve();
    });
  });
}

var PKG$1 = {
  ANDROID: 'com.iqiyi.knowledge',
  IOS: 'knowledge://mobile/register_business/com_iqiyi_knowledge'
};
var Installed =
function () {
  function Installed() {
    this.isInstalled = false;
  }
  var _proto = Installed.prototype;
  _proto.is =
  function () {
    var _is = asyncToGenerator(
    regenerator.mark(function _callee() {
      var _this = this;
      var pkg;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof iqiyi === 'undefined')) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", Promise.reject(new Error("isAppInstalled error: iqiyi not found, please detect iqiyi sdk has been installed!")));
            case 2:
              if (!this.isInstalled) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", true);
            case 4:
              pkg = PKG$1.ANDROID;
              if (detector.iOS()) {
                pkg = PKG$1.IOS;
              }
              _context.next = 8;
              return prepare();
            case 8:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                iqiyi.checkStatusApp({
                  scheme: pkg
                }, function (value) {
                  if (detector.iOS()) {
                    _this.isInstalled = value.result;
                  } else {
                    _this.isInstalled = value.data.appinstallstatus;
                  }
                  resolve(_this.isInstalled);
                });
              }));
            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    function is() {
      return _is.apply(this, arguments);
    }
    return is;
  }();
  return Installed;
}();
var installed = new Installed();

var sleep = function sleep(timestamp) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, timestamp);
  });
};

var REGISTRATION = {
  app: {
    bizId: 1400,
    bizSub: {
      category: 1,
      column: 7,
      discovery: 2,
      coupon_center: 18,
      category_filter: 20,
      category_all: 21,
      learning: 2,
      "package": 26,
      lecturer: 15,
      set_meal_payment: 205,
      column_refresh: 204,
      svideo: 32,
      ticket_columns: 25,
      group_pay: 24,
      user_order: 10,
      virtual_cash: 38,
      work_detail: 29,
      evaluation_detail: 39,
      all_evaluation: 33,
      evaluation_close_webview: 206,
      evaluation_publish: 34
    }
  },
  plugin: {
    bizId: 14,
    bizSub: {
      category: 12,
      column: 7,
      discovery: 2,
      coupon_center: 18,
      category_filter: 20,
      category_all: 21,
      user_favor: 3,
      "package": 26,
      lecturer: 15,
      set_meal_payment: 205,
      column_refresh: 204,
      svideo: 32,
      ticket_columns: 25,
      group_pay: 24,
      user_order: 10,
      virtual_cash: 38,
      work_detail: 29,
      evaluation_close_webview: 206,
      evaluation_publish: 34
    }
  }
};

var common = {
  getBizStr: function getBizStr(config) {
    var schema = config.schema,
        type = config.type;
    if (!type) {
      throw new Error("getBizStr error: config type not set");
    }
    if (!schema) {
      throw new Error("getBizStr error: config schema not set");
    }
    var bizParams = {
      biz_params: '',
      biz_extend_params: '',
      biz_dynamic_params: config.dynamic || '',
      biz_statistics: config.statistics || ''
    };
    var _REGISTRATION$app = REGISTRATION.app,
        bizSub = _REGISTRATION$app.bizSub,
        bizId = _REGISTRATION$app.bizId;
    var defaultBizSubId = bizSub.category;
    if (schema === SCHEMA.PLUGIN) {
      bizSub = REGISTRATION.plugin.bizSub;
      bizId = REGISTRATION.plugin.bizId;
      defaultBizSubId = bizSub.category;
    }
    if (Object.hasOwnProperty.call(bizSub, type)) {
      bizParams.biz_sub_id = bizSub[type];
    } else {
      bizParams.biz_sub_id = defaultBizSubId;
    }
    return JSON.stringify({
      biz_id: bizId,
      biz_plugin: PKG.ANDROID,
      biz_params: bizParams
    });
  },
  getAppSchemaURL: function getAppSchemaURL(str) {
    return "knowledge://mobile/register_business/com_iqiyi_knowledge?pluginParams=" + encodeURIComponent(encodeURIComponent(str));
  },
  getPluginSchemaURL: function getPluginSchemaURL(str) {
    return "iqiyi://mobile/register_business/com_iqiyi_knowledge?pluginParams=" + encodeURIComponent(encodeURIComponent(str));
  },
  getIqiyiSchemaURL: function getIqiyiSchemaURL(str) {
    return "iqiyi://mobile/register_business/qyclient?pluginParams=" + encodeURIComponent(encodeURIComponent(str));
  },
  getUniversalURL: function getUniversalURL(schema, pluginParams) {
    if (pluginParams === void 0) {
      pluginParams = '';
    }
    if (detector.iqiyi()) {
      if (schema === SCHEMA.PLUGIN) {
        return this.getPluginSchemaURL(pluginParams);
      }
      if (schema === SCHEMA.IQIYI) {
        return this.getIqiyiSchemaURL(pluginParams);
      }
    }
    if (schema === SCHEMA.KNOWLEDGE) {
      return URL.zhishiULink + "?pluginParams=" + encodeURIComponent(encodeURIComponent(pluginParams));
    }
    return URL.iqiyiULink + "?pluginParams=" + encodeURIComponent(encodeURIComponent(pluginParams));
  },
  getBrowserSchemaURL: function getBrowserSchemaURL(bizStr, schema) {
    var baseURL = URL.zhishiQQLink;
    var schemaURL = this.getAppSchemaURL(bizStr);
    if (schema === SCHEMA.PLUGIN) {
      baseURL = URL.iqiyiQQLink;
      schemaURL = this.getPluginSchemaURL(bizStr);
    } else if (schema === SCHEMA.IQIYI) {
      baseURL = URL.iqiyiQQLink;
      schemaURL = this.getIqiyiSchemaURL(bizStr);
    }
    return detector.wechat() ? baseURL + "&android_schema=" + encodeURIComponent(schemaURL) : schemaURL;
  },
  asyncOpenLink: function () {
    var _asyncOpenLink = asyncToGenerator(
    regenerator.mark(function _callee(url) {
      var timestamp, isBrowserHidden;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              timestamp = 3000;
              if (detector.iOS() && !detector.iOSEgt9()) {
                timestamp = 5000;
              }
              if (!(detector.chrome() || detector.iOSEgt9() || detector.wechat())) {
                _context.next = 8;
                break;
              }
              _context.next = 5;
              return sleep(200);
            case 5:
              window.location.href = url;
              _context.next = 9;
              break;
            case 8:
              this.openWithFrame(url);
            case 9:
              _context.next = 11;
              return sleep(timestamp);
            case 11:
              isBrowserHidden = document.hidden || document.webkitHidden;
              if (isBrowserHidden) {
                _context.next = 14;
                break;
              }
              return _context.abrupt("return", Promise.reject());
            case 14:
              return _context.abrupt("return", Promise.resolve());
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    function asyncOpenLink(_x) {
      return _asyncOpenLink.apply(this, arguments);
    }
    return asyncOpenLink;
  }(),
  download: function download(schema, _download) {
    if (schema === void 0) {
      schema = SCHEMA.KNOWLEDGE;
    }
    if (_download === void 0) {
      _download = false;
    }
    var url = URL.iqiyiLink;
    if (schema === SCHEMA.KNOWLEDGE) {
      if (_download) {
        url = URL.zhishiOtaLink;
      } else {
        url = URL.zhishiLink;
      }
    }
    if (typeof _download === 'string') {
      if (_download.startsWith('http') || _download.startsWith('//')) {
        url = _download;
      }
    }
    if (detector.vivo()) {
      this.openWithFrame(url);
    } else {
      location.href = url;
    }
  },
  openWithFrame: function openWithFrame(url) {
    var iframeElement = document.getElementById('open_app_iframe');
    if (!iframeElement) {
      iframeElement = document.createElement('iframe');
      iframeElement.id = 'open_app_iframe';
      iframeElement.classList.add('dn');
      iframeElement.setAttribute('name', 'open_app_iframe');
      document.body.appendChild(iframeElement);
    }
    iframeElement.setAttribute('src', url);
  },
  openWithBrowser: function openWithBrowser(schema, bizStr, download) {
    var _this = this;
    if (schema === void 0) {
      schema = SCHEMA.KNOWLEDGE;
    }
    if (download === void 0) {
      download = false;
    }
    this.asyncOpenLink(this.getBrowserSchemaURL(bizStr, schema))["catch"](function () {
      _this.download(schema, download);
    });
  },
  openWithRegistration: function openWithRegistration(schema, bizStr) {
    if (detector.iOS()) {
      location.href = schema === SCHEMA.KNOWLEDGE ? this.getUniversalURL(schema, bizStr) : this.getPluginSchemaURL(bizStr);
    } else {
      location.href = schema === SCHEMA.KNOWLEDGE ? this.getAppSchemaURL(bizStr) : this.getPluginSchemaURL(bizStr);
    }
  },
  openWithUniversalLink: function openWithUniversalLink(schema, pluginParams) {
    location.href = this.getUniversalURL(schema, pluginParams);
  }
};

var index = {
  prepare: function prepare() {
    if (detector.iqiyi()) {
      installed.is();
    }
  },
  isInstalled: function () {
    var _isInstalled = asyncToGenerator(
    regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return installed.is();
            case 3:
              return _context.abrupt("return", _context.sent);
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", false);
            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }));
    function isInstalled() {
      return _isInstalled.apply(this, arguments);
    }
    return isInstalled;
  }(),
  open: function () {
    var _open = asyncToGenerator(
    regenerator.mark(function _callee2(config) {
      var _bizStr, isInstalled, bizStr;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (typeof config.download === 'undefined') {
                config.download = false;
              }
              if (!detector.zhishi()) {
                _context2.next = 8;
                break;
              }
              config.schema = SCHEMA.KNOWLEDGE;
              _bizStr = common.getBizStr(config);
              if (_bizStr) {
                _context2.next = 6;
                break;
              }
              throw new Error('open error: detect app and reg type in app not support!');
            case 6:
              common.openWithRegistration(config.schema, _bizStr);
              return _context2.abrupt("return");
            case 8:
              if (!detector.iqiyi()) {
                _context2.next = 21;
                break;
              }
              if (typeof config.schema === 'undefined') {
                config.schema = SCHEMA.PLUGIN;
              }
              if (!(config.schema === SCHEMA.PLUGIN)) {
                _context2.next = 13;
                break;
              }
              common.openWithRegistration(config.schema, common.getBizStr(config));
              return _context2.abrupt("return");
            case 13:
              _context2.next = 15;
              return installed.is();
            case 15:
              isInstalled = _context2.sent;
              if (isInstalled) {
                _context2.next = 19;
                break;
              }
              if (detector.android()) {
                common.download(SCHEMA.KNOWLEDGE, config.download);
              } else {
                common.openWithUniversalLink(SCHEMA.KNOWLEDGE, '');
              }
              return _context2.abrupt("return");
            case 19:
              common.openWithRegistration(SCHEMA.KNOWLEDGE, common.getBizStr(config));
              return _context2.abrupt("return");
            case 21:
              if (!config.link) {
                _context2.next = 24;
                break;
              }
              location.href = config.link;
              return _context2.abrupt("return");
            case 24:
              if (typeof config.schema === 'undefined') {
                config.schema = SCHEMA.KNOWLEDGE;
              }
              bizStr = common.getBizStr(config);
              this.openGeneric(config.schema, bizStr, config.download);
            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
    function open(_x) {
      return _open.apply(this, arguments);
    }
    return open;
  }(),
  openHomeInApp: function openHomeInApp(config) {
    if (config === void 0) {
      config = {};
    }
    this.open(_extends_1({
      schema: SCHEMA.KNOWLEDGE,
      type: 'category'
    }, config));
  },
  openColumnInApp: function openColumnInApp(mediaParam, config) {
    if (config === void 0) {
      config = {};
    }
    if (typeof mediaParam === 'object') {
      this.openOptimizedColumnInApp(mediaParam.albumId, mediaParam.videoId, mediaParam.playType, mediaParam.sourceType, config);
    } else {
      this.open(_extends_1({
        schema: SCHEMA.KNOWLEDGE,
        type: 'column',
        dynamic: "id=" + mediaParam
      }, config));
    }
  },
  openColumn: function openColumn(mediaParam, config) {
    if (config === void 0) {
      config = {};
    }
    if (typeof mediaParam === 'object') {
      this.openOptimizedColumn(mediaParam.albumId, mediaParam.videoId, mediaParam.playType, mediaParam.sourceType, config);
    } else {
      this.open(_extends_1({
        type: 'column',
        dynamic: "id=" + mediaParam,
        link: "//zhishi.m.iqiyi.com/column?columnId=" + mediaParam
      }, config));
    }
  },
  openOptimizedColumn: function openOptimizedColumn(albumId, videoId, playType, sourceType, config) {
    if (playType === void 0) {
      playType = 'VIDEO';
    }
    if (config === void 0) {
      config = {};
    }
    if (!videoId || !playType || !sourceType) {
      this.openColumn(albumId);
      return;
    }
    this.open(_extends_1({
      type: 'column',
      dynamic: "id=" + albumId + "&album_id=" + albumId + "&video_id=" + videoId + "&playType=" + playType + "&sourceType=" + sourceType,
      link: "//zhishi.m.iqiyi.com/column?columnId=" + albumId
    }, config || {}));
  },
  openOptimizedColumnInApp: function openOptimizedColumnInApp(albumId, videoId, playType, sourceType, config) {
    if (playType === void 0) {
      playType = 'VIDEO';
    }
    if (config === void 0) {
      config = {};
    }
    if (!videoId || !playType || !sourceType) {
      this.openColumnInApp(albumId);
      return;
    }
    this.open(_extends_1({
      schema: SCHEMA.KNOWLEDGE,
      type: 'column',
      dynamic: "id=" + albumId + "&album_id=" + albumId + "&video_id=" + videoId + "&playType=" + playType + "&sourceType=" + sourceType
    }, config || {}));
  },
  openGeneric: function () {
    var _openGeneric = asyncToGenerator(
    regenerator.mark(function _callee3(schema, bizStr, download) {
      var obj, tmp, whitelist, arr;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (download === void 0) {
                download = false;
              }
              if (!(detector.iOSEgt9() && detector.uc())) {
                _context3.next = 4;
                break;
              }
              common.openWithBrowser(schema, bizStr, download);
              return _context3.abrupt("return");
            case 4:
              if (!(detector.android() && detector.baidu())) {
                _context3.next = 7;
                break;
              }
              common.download(schema, download);
              return _context3.abrupt("return");
            case 7:
              if (!detector.iOSEgt9()) {
                _context3.next = 10;
                break;
              }
              common.openWithUniversalLink(schema, bizStr);
              return _context3.abrupt("return");
            case 10:
              if (!(location.href.indexOf('zhishi.iqiyi.com/kpp/download') > -1 || location.href.indexOf('zhishi.m.iqiyi.com/campaign/download') > -1)) {
                _context3.next = 13;
                break;
              }
              common.openWithBrowser(schema, bizStr, true);
              return _context3.abrupt("return");
            case 13:
              _context3.prev = 13;
              _context3.next = 16;
              return Ajax.get('//api-kpp.if.iqiyi.com/api/v1/cms/config/cc?ccKey=h5_special_ua');
            case 16:
              obj = _context3.sent;
              if (!(obj.resultCode !== 'A00000')) {
                _context3.next = 20;
                break;
              }
              common.openWithBrowser(schema, bizStr, download);
              return _context3.abrupt("return");
            case 20:
              tmp = JSON.parse(obj.data);
              whitelist = tmp.directDownload;
              if (!tmp.cannotDownload) {
                tmp.cannotDownload = [];
              }
              if (!whitelist) {
                whitelist = [];
              }
              whitelist = whitelist.concat(tmp.cannotDownload);
              arr = whitelist.filter(function (item) {
                return navigator.userAgent.indexOf(item) > -1;
              });
              if (!(arr.length > 0)) {
                _context3.next = 29;
                break;
              }
              common.download(schema, false);
              return _context3.abrupt("return");
            case 29:
              common.openWithBrowser(schema, bizStr, download);
              _context3.next = 35;
              break;
            case 32:
              _context3.prev = 32;
              _context3.t0 = _context3["catch"](13);
              common.openWithBrowser(schema, bizStr, download);
            case 35:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[13, 32]]);
    }));
    function openGeneric(_x2, _x3, _x4) {
      return _openGeneric.apply(this, arguments);
    }
    return openGeneric;
  }(),
  openAppleStore: function openAppleStore() {
    location.href = 'https://apps.apple.com/cn/app/id1454757308';
  },
  download: function download(schema, _download) {
    if (schema === void 0) {
      schema = SCHEMA.KNOWLEDGE;
    }
    if (_download === void 0) {
      _download = true;
    }
    common.download(schema, _download);
  }
};

export default index;
